/*
 * Copyright 2017-present Evernote Corporation. All rights reserved.
 */

import { SubscriberHandler } from './types';
import Message from './message';

/**
 * A single subscriber to a topic
 */
class Subscriber {
  handler: SubscriberHandler;

  constructor(handler: SubscriberHandler) {
    this.handler = handler;
  }

  /**
   * Given a message, it actually calls the handler on the message. In effect
   * "sending" the message to the subscriber
   * @method emit
   * @param  {BrokerMessage} message The message to send
   * @return {void}
   */
  emit<T>(message: Message<T>): void {
    this.handler(message);
  }
}

export default Subscriber;
